export default {
    HOME_PAGE: {
        link: '/home',
        title: 'Accueil Support',
    },
    SUPPORT_ROOT: {
        link: '/support',
        title: 'Support',
    },
    FAQ_PAGE: {
        link: '/support/faq',
        title: 'Foire aux questions',
    },
    CONTACT_BY_EMAIL: {
        link: '/support/contact/email',
        title: 'Contacter le support par email',
    },
    CONTACT_SUPPORT_SUCCESS: {
        link: '/support/contact/email/success',
        title: 'Contacter le support par email',
    },
    CONTACT_SALESMAN: {
        link: '/salesman',
        title: 'Contacter le support par téléphone',
    },
    CONTACT_SALESMAN_SUCCESS: {
        link: '/salesman/success',
        title: 'Contacter le support par téléphone',
    },
};
